import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Transaction } from "../../types/transactionType";
import { api } from "../../config/Api";

interface TransationState{
    transactions:Transaction[];
    transaction:Transaction|null;
    loading:boolean;
    error:string|null
}

const initialState:TransationState={
    transactions:[],
    transaction:null,
    loading:false,
    error:null
}

export const fetchTransactionsBySeller = createAsyncThunk<
  Transaction[], // Return type
  void,
//   string,        // Argument type (jwt in this case)
  { rejectValue: string } // Rejection value type
>(
  'transaction/fetchTransactionsBySeller',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get<Transaction[]>('/api/transaction/seller');

      return response.data;
    } catch (error: any) {
      if (error.response) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue('Failed to fetch transactions');
    }
  }
);

const transactionSlice = createSlice({
    name:"transaction",
    initialState,
    reducers:{},
    extraReducers:(builder) => { 
        builder.addCase(fetchTransactionsBySeller.pending,(state)=>{
            state.loading = true;
            state.error =""
        }).addCase(fetchTransactionsBySeller.fulfilled,(state,action:PayloadAction<Transaction[]>)=>{
            state.loading = false;
            state.transactions =action.payload
        })
        .addCase(fetchTransactionsBySeller.rejected,(state)=>{
            state.loading = false;
            state.error ="Failed to fetch transaction by seller"
        })
     }
})

export const transactionSliceReducer = transactionSlice.reducer